module.exports = __webpack_public_path__ + "static/img/cont2403.430f6f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2403.jpg
// module id = AHMp
// module chunks = 0